import { ReactElement } from 'react';

import {
   CurrentHealthcareProviderAvailablePatientPortalServiceQuery,
   PatientPortalService,
} from '@dreryk/egabinet-patient-portal-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { boundServiceTranslationKeys } from '../../../translations';

import { HealthcareProviderPatientPortalBoundServiceCreateFormController } from './healthcareProviderPatientPortalBoundServiceCreate.types';

const healthcareProviderPatientPortalServicesSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<PatientPortalService[]> =>
      performCqrsQuerySearch<PatientPortalService>(() => {
         const query = new CurrentHealthcareProviderAvailablePatientPortalServiceQuery();
         query.name = searchText ? TextPattern.anywhereIgnoreCase(searchText) : TextPattern.any();
         return query;
      });
};

const triggerLabelExtractor = (patientPortalService: PatientPortalService): string => patientPortalService.name;

type PatientPortalServiceSelectProps = {
   readonly register: HealthcareProviderPatientPortalBoundServiceCreateFormController['register'];
};

export const PatientPortalServiceSelect = (props: PatientPortalServiceSelectProps): ReactElement => {
   return (
      <Select
         testId={'patientPortalService'}
         triggerLabelExtractor={triggerLabelExtractor}
         controller={props.register('patientPortalService', { required: true })}
         placeholder={boundServiceTranslationKeys.choosePatientPortalService}
         label={boundServiceTranslationKeys.patientPortalService}
         searchInputEnabled
      >
         <Select.SearchCreator<PatientPortalService>
            searchCreator={healthcareProviderPatientPortalServicesSearchCreator}
         >
            {({ items: patientPortalServices }) => (
               <Select.List<PatientPortalService> items={patientPortalServices} keyExtractor={'id'}>
                  {(patientPortalService) => (
                     <Select.Item<PatientPortalService>
                        item={patientPortalService}
                        testId={patientPortalService.name}
                        label={createTranslatedText(patientPortalService.name)}
                     />
                  )}
               </Select.List>
            )}
         </Select.SearchCreator>
      </Select>
   );
};
